/* Makes every Instant accordion work even if the theme’s core JS is missing.
   Works out-of-the-box with the data-instant-type conventions and
   honours the data-is-multi-open-enabled="false/true" flag. */

document.addEventListener('DOMContentLoaded', () => {
  /* Find every section rendered by this Liquid file */
  document
    .querySelectorAll('[data-instant-type="accordion-container"]')
    .forEach(container => {
      const singleOpen = container.dataset.isMultiOpenEnabled === 'false';

      container
        .querySelectorAll('[data-instant-type="accordion-header"]')
        .forEach(header => {
          header.addEventListener('click', () => {
            const item = header.parentElement;                // <div data-instant-type="accordion-item">
            const openNow = item.dataset.state === 'open';

            /* Close others if only one panel may stay open */
            if (singleOpen) {
              container
                .querySelectorAll('[data-instant-type="accordion-item"]')
                .forEach(el => el.dataset.state = 'closed');
            }

            /* Toggle current panel */
            item.dataset.state = openNow ? 'closed' : 'open';
          });
        });
    });
});
